import { createSlice } from "@reduxjs/toolkit";

const ingredientQtySlice = createSlice({
  name: "ingredientQty",
  initialState: {
    totalQty: null,
    // Master-batch remaining (master − Σ all ingredients across all ops), from the backend.
    // SubOperationDetails seeds its live master counter from this.
    remainingQty: null,
    unit: "",
    // Configured input-based ingredient (recipe metadata). The live counter for this lives
    // in SubOperationDetails; here we only hold the authoritative backend values.
    configuredIngredientId: null,
    configuredIngredientName: null,
    configuredIngredientRemaining: null,
  },
  reducers: {
    setTotalQty: (state, action) => {
      state.totalQty = action.payload.totalQty;
      state.unit = action.payload.unit || "";
      const existing = parseFloat(action.payload.existingSum) || 0;
      state.remainingQty = action.payload.totalQty !== null ? action.payload.totalQty - existing : null;
      const ing = action.payload.inputIngredient;
      if (ing) {
        state.configuredIngredientId = ing.ingredient_id ?? null;
        state.configuredIngredientName = ing.ingredient_name ?? null;
        state.configuredIngredientRemaining = ing.remaining_quantity ?? null;
      } else {
        state.configuredIngredientId = null;
        state.configuredIngredientName = null;
        state.configuredIngredientRemaining = null;
      }
    },
  },
});

export const { setTotalQty } = ingredientQtySlice.actions;
export default ingredientQtySlice.reducer;
